export var ConnectSymbol = Symbol('connect');
